import axios, { AxiosResponse } from 'axios';

export const getUser = (): Promise<AxiosResponse> => axios.get(`/auth/me`);
